// copyableText.js — S-A8 copy-to-clipboard source extraction (small).
//
// The copy button on a durable assistant turn must put the RAW MARKDOWN SOURCE on the clipboard,
// NOT the rendered HTML. A timeline turn (see chatTimeline.js mergeTimeline) is shaped
// { role, text, messageId, seq } where `text` is the concatenated raw markdown content the model
// emitted (e.g. "**hi**", not "<strong>hi</strong>"). So copyableText returns that raw string —
// react-markdown renders it for display, but the user copies what the model actually wrote.
//
// Pure + import-free → node-testable under `node --test`.

export function copyableText(turn) {
  if (!turn) return ""
  // Prefer the raw concatenated markdown `text`; fall back to `content` for alternate shapes.
  if (typeof turn.text === "string") return turn.text
  if (typeof turn.content === "string") return turn.content
  return ""
}
